import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import { IAccreditation } from "@/types/page";
import adminAxios from "@/lib/axios";

export async function createAccreditation(payload: Partial<IAccreditation>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.ACCREDITATION.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateAccreditation(id: number, payload: Partial<IAccreditation>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.ACCREDITATION.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
